module.exports = __webpack_public_path__ + "static/media/tp9.819bedbf.jpg";